// extracted by mini-css-extract-plugin
export var container = "styles-module__container___RtKrP";
export var innerContainer = "styles-module__innerContainer___itc7X";
export var top = "styles-module__top___sccFx";
export var title = "styles-module__title___mkU7O";
export var subtitle = "styles-module__subtitle___tiILj";
export var content = "styles-module__content___a5kQK";
export var contentTitle = "styles-module__contentTitle___NelV1";
export var typeReason = "styles-module__typeReason___loMy4";
export var inputHalfContainer = "styles-module__inputHalfContainer___d1Ygi";
export var input = "styles-module__input____Ynyh";
export var type = "styles-module__type___DAr8j";
export var propertyContainer = "styles-module__propertyContainer___EWdSq";
export var descriptionContainer = "styles-module__descriptionContainer___zc5F4";
export var dateLabelsContainer = "styles-module__dateLabelsContainer___JBWPn";
export var dateLabel = "styles-module__dateLabel___mRtuF";
export var datesContainer = "styles-module__datesContainer____f78Q";
export var startDate = "styles-module__startDate___qWvjJ";
export var annualToggleContainer = "styles-module__annualToggleContainer___JYlRn";
export var annualToggleLabel = "styles-module__annualToggleLabel___JMczf";
export var bottom = "styles-module__bottom___ISgLj";
export var spinner = "styles-module__spinner___pS1lr";
export var error = "styles-module__error___iVjs3";